module.exports = "/_next/static/Components/Solution/4d5cccde2e76298033e600715079e79d.png";